import script from "./dispose-trust-context-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./dispose-trust-context-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__